import React, { useEffect, useState } from "react";
import Aux from "react-aux";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  FormSelect,
} from "shards-react";

import { useHistory } from "react-router-dom";
import { doDelete, doPost } from "../../../backend/common";
import { printType } from "../user/type";

function deleteUser(user, callback) {
  //console.log("### DELETE USER##", user);
  const params = { username: user.username };
  doDelete("/register", params, callback).then();
}

function changePrivileges(user, type, callback) {
  //console.log("### CHANGE USER##", user);
  const params = { username: user.username };
  const body = { type: type };
  doPost("/admin/type", params, body, callback).then();
}

function priviledgeButtons(user, refreshUsers) {
  if (user.type === "admin") {
    return (
      <Aux>
        <td>
          <Button
            pill
            theme="secondary"
            onClick={() => {
              changePrivileges(user, "producer", () => {
                refreshUsers();
              });
            }}
          >
            Hacer productor
          </Button>
        </td>
        <td>
          <Button
            pill
            theme="primary"
            onClick={() => {
              changePrivileges(user, "consumer", () => {
                refreshUsers();
              });
            }}
          >
            Hacer consumidor
          </Button>
        </td>
      </Aux>
    );
  }
  if (user.type === "consumer") {
    return (
      <Aux>
        <td>
          <Button
            pill
            theme="secondary"
            onClick={() => {
              changePrivileges(user, "producer", () => {
                refreshUsers();
              });
            }}
          >
            Hacer productor
          </Button>
        </td>
        <td>
          <Button
            pill
            theme="warning"
            onClick={() => {
              changePrivileges(user, "admin", () => {
                refreshUsers();
              });
            }}
          >
            Hacer administrador
          </Button>
        </td>
      </Aux>
    );
  }
  if (user.type === "producer") {
    return (
      <Aux>
        <td>
          <Button
            pill
            theme="primary"
            onClick={() => {
              changePrivileges(user, "consumer", () => {
                refreshUsers();
              });
            }}
            className={"mr-2"}
          >
            Hacer consumidor
          </Button>
        </td>
        <td>
          <Button
            pill
            theme="warning"
            onClick={() => {
              changePrivileges(user, "admin", () => {
                refreshUsers();
              });
            }}
            className={"mr-2"}
          >
            Hacer administrador
          </Button>
        </td>
      </Aux>
    );
  }
}

const UsersTables = ({ users, refreshUsers }) => {
  const history = useHistory();
  const [user, setUser] = useState("");

  // Wait for props to load
  useEffect(() => {
    if (users.length > 0) setUser(users[0]);
  }, [users]);

  const onChange = (event) => {
    setUser(users[event.target.value]);
  };

  return (
    <Card small className="mb-4">
      <CardHeader className="border-bottom">
        <h6 className="m-0">Usuarios</h6>
      </CardHeader>
      <CardBody className="p-0 pb-3">
        <Col style={{ padding: 15 }}>
          <FormSelect onChange={onChange}>
            {users.map((value, index) => (
              <option value={index} key={`option-user-${index}`}>
                {value.username}
              </option>
            ))}
          </FormSelect>
          <div
            style={{
              overflowX: "auto",
              display: "block",
              WebkitOverflowScrolling: "touch",
              width: "100%",
            }}
          >
            <table className="table mb-0">
              <thead className="bg-light">
                <tr>
                  <th scope="col" className="border-0">
                    Nick
                  </th>
                  <th scope="col" className="border-0">
                    Email
                  </th>
                  <th scope="col" className="border-0">
                    Tipo
                  </th>
                  <th scope="col" className="border-0">
                    Privilegios
                  </th>
                  <th scope="col" className="border-0">
                    Acciones
                  </th>
                </tr>
              </thead>
              <tbody style={{ maxHeight: "500px" }}>
                <tr>
                  <td>{user.nick}</td>
                  <td>{user.username}</td>
                  <td>{printType(user)}</td>
                  <td>
                    {user.privileges === "admin" ? (
                      <Badge theme="warning">administrador</Badge>
                    ) : (
                      <Badge theme="light">usuario</Badge>
                    )}
                  </td>
                  <tr>
                    <td>
                      <Button
                        pill
                        theme="info"
                        onClick={() => {
                          history.push({
                            pathname: "/profile",
                            state: { activeUser: user },
                          });
                        }}
                      >
                        Perfil
                      </Button>
                    </td>
                    <td>
                      <Button
                        pill
                        theme="success"
                        onClick={() => {
                          history.push({
                            pathname: "/new-price",
                            state: { activeUser: user },
                          });
                        }}
                      >
                        Nuevo precio
                      </Button>
                    </td>

                    {priviledgeButtons(user, refreshUsers)}

                    <td>
                      <Button
                        pill
                        theme="danger"
                        onClick={() => {
                          deleteUser(user, () => {
                            refreshUsers();
                          });
                        }}
                      >
                        Eliminar
                      </Button>
                    </td>
                  </tr>
                </tr>
              </tbody>
            </table>
          </div>
        </Col>
      </CardBody>
    </Card>
  );
};
UsersTables.defaultProps = {
  users: [],
};
export default UsersTables;
